<template>
<div class="container-fluid" >
  <div id="arrow" class="container-fluid">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3000 200">
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="6"
        refX="0" refY="3.5" orient="auto" :stroke="this.color" :fill="this.color">
          <polygon points="0 1.8, 5 3.5, 0 5" />
        </marker>
      </defs>
      <line x1="0" y1="95" x2="10%" y2="95" :stroke="this.color"
      stroke-width="35" marker-end="url(#arrowhead)" />
    </svg>
    <h1 class="text-uppercase">{{name}}</h1>
  </div>
</div>
</template>

<script>
window.jQuery = window.$ = require('jquery')
require('velocity-animate')
export default{
  data(){
    return{
      animStart: false,
      animFinished: true,
      scrolling: false
    }
  },
  props: ['name', 'selector', 'color'],
  methods:{
    animationActive(active){
      if(active){
         $('line').velocity('stop', true).velocity({x2 : '85%'}, {
           duration: '1000',
            begin: () => {
              this.animStart = true
              this.animFinished = false
            },
            complete: () => {
              this.animStart = false
              this.animFinished = true
            }
        })
      } else {
        $('line').velocity('stop', true).velocity(
          {x2: '10%'}, {
          duration: '500',
          begin: () => {
            this.animStart = true
            this.animFinished = false
          },
          complete: () => {
            this.animStart = false
            this.animFinished = true
          }
        })
      }
    },
    scrollIntoView(elem){
      var docViewTop = $(window).scrollTop()
      var docViewBottom = docViewTop + $(window.parent).height()
      var elemTop = $(elem).offset().top + 100
//      var elemBottom = elemTop + $(elem).height() - 400
      // if(!this.animStart && (elemBottom <= docViewBottom) && (elemTop >= docViewTop)){
      if(!this.animStart && (docViewBottom <= elemTop)){
        this.animationActive(true)
      } else {
        if(this.animFinished){
          this.animationActive(false)
        }
      }
    }
  },
  mounted(){
    console.log(this.selecor)
    this.scrollIntoView('#' + this.selector)
    $(window).scroll(() => {
       this.scrollIntoView('#' + this.selector)
    })
  }
}
</script>

<style lang="scss" scoped>
#arrow{
  padding: 25px 0 0;
  svg{
    width: 80%;
    position: absolute;
  }
  h1{
    text-align: right;
    padding-right: 10%;
  }
}
</style>



// WEBPACK FOOTER //
// ArrowRight.vue?41d16de5